export const taskCodesBidItemFor888 = ["777", "860", "861", "870", "880", "888", "920", "970", "980"];

const dateNow = new Date();
dateNow.setMonth(dateNow.getMonth() - 1);

const year = dateNow.getFullYear();
const month = dateNow.getMonth() + 1;
const day = dateNow.getDate();

export const date = new Date(`${month}-${day}-${year}`);